import { setLocale } from "yup";

export default function configureYupI18n(i18n) {
  // Set the locale for Yup
  setLocale({
    mixed: {
      required: () => i18n.t("validation.required"),
    },
    string: {
      email: () => i18n.t("validation.email"),
      matches: ({ label }) => i18n.t("validation.phone", { label }),
    },
  });
}
